module.exports = __webpack_public_path__ + "img/linkedin2.afb6bd4c.svg";